module.exports = __webpack_public_path__ + "img/dai6.91c0e5bd.png";